import AppProviders from 'app/providers/AppProviders';
import AppRouter from 'app/router/AppRouter';
import HtmlPagePreview from 'features/html-reporting/PagePreview';

// The credential-free preview host receives intercepted tool snapshots only.
// Avoid bootstrapping login, preferences, telemetry or external OAuth scripts.
const App = () => window.location.pathname === '/html-preview' ? <HtmlPagePreview /> : (
    <AppProviders>
        <AppRouter />
    </AppProviders>
);

export default App;
